import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "m4 4 7.07 17 2.51-7.39L21 11.07z", stroke: `${color}` })
    }
  );
};
Icon.displayName = "MousePointer2";
const MousePointer2 = memo(themed(Icon));
export {
  MousePointer2
};
//# sourceMappingURL=mouse-pointer-2.js.map
